export const PAIR_ROUTE_SEGMENT = 'pair';

const PAIRING_CODE_REGEX = /^[A-Z0-9]{8}$/;

/**
 * Format pairing code with dash (ABCD-1234)
 */
export function formatPairingCode(code: string): string {
  if (code.length !== 8) {
    return code;
  }

  return `${code.slice(0, 4)}-${code.slice(4)}`;
}

export function isValidPairingCode(pairingCode: string) {
  return PAIRING_CODE_REGEX.test(pairingCode);
}

export function buildInvitationUrl(tenant: string, pairingCode: string) {
  return `${window.location.origin}/${tenant}/${PAIR_ROUTE_SEGMENT}/${pairingCode}`;
}

/**
 * Builds the pairing landing URL to encode into a QR code. Scanning it with a
 * phone's native camera opens the install / open-app page, which deep-links
 * into the NewCore app. Falls back to the raw code when the tenant is unknown
 * or the code is malformed, so the QR is never broken.
 */
export function buildPairingQrValue(pairingCode: string, tenant?: string) {
  if (!tenant || !isValidPairingCode(pairingCode)) {
    return pairingCode;
  }

  return buildInvitationUrl(tenant, pairingCode);
}
